import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { EventsTypeEnum } from 'src/app/domain/registration/enums/events-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { TypeQuestionEventsEnum } from 'src/app/domain/registration/enums/type-question-events.enum';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { LimitQuestionEventsEnum, TypesEventsEnum } from 'src/app/domain/registration/enums/types-events.enum';
import { SystemIndexSelectComponent } from '../systems/crud-index/crud-index-select.component';
import { SystemTypeEnum, SystemTypeIdEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { PartnerIndexMultiSelectComponent } from '../partners/crud-index/crud-index-multiselect.component';
import { PartnerIndexSelectComponent } from '../partners/crud-index/crud-index-select.component';

export const RELATIVE_URL = 'event-forms';
export const COLUMNS_TO_SHOW_WEB = [
  'select',
  'image',
  'code',
  'description',
  'typeQuestion',
  'createdAt',
  'actions',
];

export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    link_show: true,
    field_type: FieldTypeEnum.INPUT,
    property: 'EventForms',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE}`,
  },
  {
    link_show: true,
    field_type: FieldTypeEnum.LABEL,
    property: 'code',
    display: 'CÓDIGO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE}`,
  },
  {
    link_show: true,
    field_type: FieldTypeEnum.IMAGE,
    property: 'image',
    display: 'IMAGEM',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} image-size`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'type',
    display: 'TIPO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'description',
    display: 'DESCRIÇÃO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'name',
    display: 'NOME',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'enterprise',
    display: 'EMPRESA',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'telephone',
    display: 'TELEFONE',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'instagram',
    display: 'INSTAGRAM',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'mail',
    display: 'EMAIL',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'photo',
    display: 'FOTO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'question',
    display: 'Faça uma pergunta',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'newQuestion',
    display: 'Nova pergunta',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'limit',
    display: 'LIMITE DE PERGUNTAS',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'typeQuestion',
    display: 'TIPO DE FORMULÁRIO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'financial',
    display: 'FINANCEIRO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    formatter: (value: boolean) => (value ? 'Sim' : 'Não'),
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'legal',
    display: 'JURÍDICO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    formatter: (value: boolean) => (value ? 'Sim' : 'Não'),
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'consultant',
    display: 'CONSULTOR',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    formatter: (value: boolean) => (value ? 'Sim' : 'Não'),
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'partner',
    display: 'PARCEIRO',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    formatter: (value: boolean) => (value ? 'Sim' : 'Não'),
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'representative',
    display: 'REPRESENTANTE',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    formatter: (value: boolean) => (value ? 'Sim' : 'Não'),
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'accounting',
    display: 'CONTÁBIL',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    formatter: (value: boolean) => (value ? 'Sim' : 'Não'),
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'solutions',
    display: 'SOLUÇÕES',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    formatter: (value: boolean) => (value ? 'Sim' : 'Não'),
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'plans',
    display: 'PLANOS',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    formatter: (value: boolean) => (value ? 'Sim' : 'Não'),
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'dashboard',
    display: 'PAINEL',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    formatter: (value: boolean) => (value ? 'Sim' : 'Não'),
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'support',
    display: 'SUPORTE',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    formatter: (value: boolean) => (value ? 'Sim' : 'Não'),
  },
  {
    field_type: FieldTypeEnum.LABEL,
    property: 'createdAt',
    display: 'CRIADO EM',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
];

export const CES_CONFIG_FIELDS = [
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'code',
  },
  {
    type: TypeComponentFieldEnum.IMAGE,
    name: 'image',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'DESCRIÇÃO',
    name: 'description',
    placeholder: 'Insira a descrição',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'LIMITE DE PERGUNTAS',
    name: 'limit',
    options: ['0', ...Object.values(LimitQuestionEventsEnum)],
    placeholder: 'Selecione uma opção',
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO DE FORMULÁRIO',
    name: 'typeQuestion',
    options: ['TODOS', ...Object.values(TypeQuestionEventsEnum)],
    placeholder: 'Selecione uma opção',
  },
  {
    type: TypeComponentFieldEnum.INPUT, // ou SELECT, conforme a necessidade
    label: 'NOME',
    name: 'name',
    placeholder: 'Insira seu nome',
    validation: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'EMPRESA',
    name: 'enterprise',
    options: Object.values(EventsTypeEnum),
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TELEFONE',
    name: 'telephone',
    value: EventsTypeEnum.YES,
    options: Object.values(EventsTypeEnum),
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'INSTAGRAM',
    name: 'instagram',
    value: EventsTypeEnum.YES,
    options: Object.values(EventsTypeEnum),
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'EMAIL',
    name: 'email',
    placeholder: 'Insira seu email',
    validation: [Validators.required, Validators.email],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'PERGUNTA',
    name: 'question',
    value: EventsTypeEnum.YES,
    options: Object.values(EventsTypeEnum),
  },
  {
    type: TypeComponentFieldEnum.IMAGE,
    name: 'image',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Gerar QR Code',
    name: 'highlight',
  },
  {
    labelSave: 'Salvar',
    labelCancel: 'Cancelar',
    name: 'cancelSave',
    type: TypeComponentFieldEnum.CANCEL_SAVE,
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Digite uma nova pergunta',
    name: 'newQuestion',
    placeholder: 'Insira a descrição',
    validation: [Validators.required, Validators.minLength(4)],
  },

  //Meeting Fields
  {
    type: TypeComponentFieldEnum.INPUT_DATETIME,
    label: 'DATA e HORA',
    name: 'meetingDateTime',
    placeholder: 'Selecione a data e hora',
    validation: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO',
    name: 'type',
    options: Object.values(SystemTypeEnum),
    placeholder: 'Selecione uma opção',
    validators: [Validators.required],
    valueTransform: (value: string) => SystemTypeIdEnum[value as keyof typeof SystemTypeIdEnum],
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'SOLUÇÃO',
    component: SystemIndexSelectComponent,
    componentData: {
      params: { },
    },
    name: 'system',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [Validators.required],
    dependsOn: { 
      field: 'type',
      getValue: (value: string) => SystemTypeIdEnum[value as keyof typeof SystemTypeIdEnum]
    },
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'TUTOR',
    component: PartnerIndexMultiSelectComponent,
    name: 'partners',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'LINK DA REUNIÃO',
    name: 'linkMeeting',
    placeholder: 'Insira o link da reunião',
    validation: [Validators.required, Validators.pattern('(https?://.+)')],
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'SOLUÇÃO',
    component: SystemIndexSelectComponent,
    componentData: {
      params: { type: SystemTypeIdEnum[SystemTypeEnum.SYSTEM] },
    },
    name: 'briefingSystem',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [Validators.required],
    hideSelectedValue: true
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'Cliente',
    name: 'briefingCustomer',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione o cliente',
    validation: [Validators.required],
    hideSelectedValue: true
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'Parceiro',
    name: 'briefingPartner',
    component: PartnerIndexSelectComponent,
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione o cliente',
    validation: [Validators.required],
    hideSelectedValue: true
  },
];

export const filterFields: IFieldConfig[] = [
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'DESCRIÇÃO',
    name: 'description',
    placeholder: 'Insira a descrição',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'LIMITE DE PERGUNTAS',
    name: 'limit',
    options: ['1', ...Object.values(LimitQuestionEventsEnum)],
    placeholder: 'Selecione uma opção',
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO DE FORMULÁRIO',
    name: 'typeQuestion',
    options: ['TODOS', ...Object.values(TypeQuestionEventsEnum)],
    placeholder: 'Selecione uma opção',
  },
];
